import { useDeleteHttp } from "../../http.hook";

// biome-ignore lint/suspicious/noEmptyInterface: <explanation>
interface IResponse {}

export function useRejectInvoiceDetailsTransactionAdminHttp() {
	return useDeleteHttp<null, IResponse>({
		path: "/admin/payouts/transactions/:id/invoice-details/reject",
	});
}
